export const getRightToChangeResponsible = (userRights) => {
  var hasRightToChangeResponsible = true;
  if (userRights && userRights.hasUserRight && !userRights.hasDealerAdminUserRight && !userRights.hasAdminUserRight)
    hasRightToChangeResponsible = false;
  return hasRightToChangeResponsible;
};
